import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from 'libs.nucleus';
import { formatLocaleList } from './locales_dropdown.utils';
export const LocalesDropdown = ({ locales, label, value, currentLocale, onChange }) => {
    const formattedLocales = formatLocaleList(locales, currentLocale);
    return (_jsx(Select, { required: true, dataTestId: 'locale-select', label: label, onChange: onChange, options: formattedLocales, value: value, width: 'full' }));
};
